export default __webpack_public_path__ + "static/media/aviso-indicativo-nascimento.42f7c3f9.svg";